<template>
  <div class="custom-dialog-header">
    <span class="custom-dialog-title">{{ title }}</span>
    <div class="custom-dialog-actions">
      <el-button type="text" @click="handleToggle">
        <i
          :class="
            isFullScreen ? 'fa fa-window-restore' : 'fa fa-window-maximize'
          "
          style="font-size: 18px"
        ></i>
      </el-button>
      <el-button type="text" @click="$emit('close')">
        <i class="el-icon-close" style="font-size: 18px"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomDialogHeader",
  emits: ["max", "min", "close"],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isFullScreen: false,
    };
  },
  methods: {
    handleToggle() {
      this.isFullScreen = !this.isFullScreen;
      if (this.isFullScreen) {
        this.$emit("max");
      } else {
        this.$emit("min");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/element-variables.scss";

.custom-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  min-height: 48px;
  border-bottom: 1px solid $--border-color-lighter;

  .custom-dialog-title {
    font-weight: bold;
    font-size: 16px;
  }

  .custom-dialog-actions {
    display: flex;
    align-items: center;
  }
}
</style>
